import { useEffect, useState } from 'react';

import { Breakpoint, ScreenSize } from '@models/screen';

const getScreenSize = (width: number): ScreenSize => {
  switch (true) {
    case width >= Breakpoint.large:
      return ScreenSize.LARGE;
    case width >= Breakpoint.medium:
      return ScreenSize.MEDIUM;
    default:
      return ScreenSize.SMALL;
  }
};

export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState(() => getScreenSize(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      const newSize = getScreenSize(window.innerWidth);
      setScreenSize((prev) => (prev !== newSize ? newSize : prev));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
};
